// src/components/quiz/PassageDisplay.jsx
import React from 'react';
import { BookOpen, Sparkles } from 'lucide-react';
import TranslatableText from '../TranslatableText';

export default function PassageDisplay({ passage, title }) {
  
  return (
    <div className="animate-in fade-in slide-in-from-bottom-4 duration-500">
      {/* CONTENEDOR PRINCIPAL - Efecto papel */}
      <div className="relative bg-gradient-to-br from-amber-50 via-white to-amber-50/50 border-2 border-amber-200/50 rounded-3xl p-6 md:p-8 shadow-xl shadow-amber-100/50 overflow-hidden">
        
        {/* Patrón de fondo sutil */}
        <div className="absolute inset-0 opacity-[0.03]" style={{
          backgroundImage: `repeating-linear-gradient(0deg, #000 0px, #000 1px, transparent 1px, transparent 30px)`
        }} />

        {/* Decoración superior */}
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-amber-300/30 to-transparent" />
        
        {/* HEADER CON ICONO */}
        <div className="relative flex items-center gap-3 mb-6 pb-4 border-b-2 border-amber-200/30">
          <div className="flex items-center justify-center w-10 h-10 bg-gradient-to-br from-amber-400 to-orange-500 rounded-xl shadow-md">
            <BookOpen className="text-white" size={20} strokeWidth={2.5} />
          </div>
          
          <div className="flex-1">
            {title ? (
              <h3 className="text-lg md:text-xl font-black text-slate-800 flex items-center gap-2">
                {title}
                <Sparkles size={16} className="text-amber-500" />
              </h3>
            ) : (
              <h3 className="text-lg md:text-xl font-black text-slate-800">
                📖 Reading
              </h3>
            )}
            <p className="text-xs font-bold text-slate-400 uppercase tracking-wider mt-0.5">
              Lectura
            </p>
          </div>

          {/* Indicador de tipo de contenido */}
          <div className="hidden md:flex items-center gap-1.5 px-3 py-1.5 bg-amber-100 border border-amber-200 rounded-full">
            <div className="w-2 h-2 bg-amber-500 rounded-full animate-pulse" />
            <span className="text-xs font-bold text-amber-700">PASSAGE</span>
          </div>
        </div>

        {/* CONTENIDO DEL PASSAGE */}
        <div className="relative prose prose-slate prose-lg max-w-none">
          <div className="text-slate-700 leading-relaxed md:leading-loose whitespace-pre-wrap font-serif text-base md:text-lg selection:bg-amber-200 selection:text-slate-900">
            {passage.split('\n\n').map((paragraph, idx) => (
              <p 
                key={idx} 
                className="mb-4 last:mb-0 animate-in fade-in slide-in-from-left-2 duration-500"
                style={{ animationDelay: `${idx * 100}ms` }}
              >
                 <TranslatableText text={paragraph} />
              </p>
            ))}
          </div>
        </div>

        {/* Decoración inferior */}
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-amber-300/30 to-transparent" />

        {/* Marca de agua decorativa */}
        <div className="absolute bottom-4 right-4 text-amber-200/20 font-black text-6xl md:text-8xl pointer-events-none select-none">
          "
        </div>
      </div>

      {/* ESTADÍSTICAS DE LECTURA */}
      <div className="flex items-center justify-center gap-4 mt-4 text-xs font-bold text-slate-400">
        <div className="flex items-center gap-1.5">
          <div className="w-1.5 h-1.5 bg-amber-400 rounded-full" />
          <span>{passage.split(' ').length} palabras</span>
        </div>
        <div className="w-1 h-1 bg-slate-300 rounded-full" />
        <div className="flex items-center gap-1.5">
          <div className="w-1.5 h-1.5 bg-indigo-400 rounded-full" />
          <span>~{Math.ceil(passage.split(' ').length / 200)} min de lectura</span>
        </div>
      </div>
    </div>
  );
}
